import React, { useEffect, useReducer } from "react";
import { Image } from "../../image";
import LoadingSpinner from "../../LoadingSpinner";
import { IMedia } from "../GalleryContext";
import { getVimeoId } from "../utils";

interface IVimeoThumbnailProps {
  selectedMediaIndex: number;
  media: IMedia;
}

export default function VimeoThumbnail({ selectedMediaIndex, media }: IVimeoThumbnailProps) {
  const [state, dispatch] = useVimeoThumbnailReducer();

  useEffect(() => {
    if (media.url) {
      if (typeof fetch === "function") {
        fetch(`https://vimeo.com/api/v2/video/${getVimeoId(media.url)}.json`)
          .then((response) => response.json())
          .then((data) => {
            if (data && Array.isArray(data) && data[0]) {
              dispatch({
                type: "load-thumbnail",
                imageSrc: data[0].thumbnail_large,
              });
            }
          })
          .catch(() => {
            dispatch({
              type: "failed-to-load-thumbnail",
            });
          });
      }
    }
  }, [media]);

  if (state.loading) {
    return <LoadingSpinner />;
  }

  if (state.imageSrc) {
    return (
      <Image
        borderRadius="md"
        src={state.imageSrc}
        alt={media.alt || `story gallery media ${selectedMediaIndex + 1}`}
        objectFit="cover"
        height="100%"
        width="100%"
      />
    );
  }

  return <div>Video</div>;
}

type State = {
  imageSrc: string | null;
  loading: boolean;
};

type Action =
  | {
      type: "load-thumbnail";
      imageSrc: string;
    }
  | {
      type: "failed-to-load-thumbnail";
    };

function useVimeoThumbnailReducer() {
  return useReducer(
    (state: State, action: Action) => {
      if (action.type === "load-thumbnail") {
        return {
          ...state,
          loading: false,
          imageSrc: action.imageSrc,
        };
      }

      if (action.type === "failed-to-load-thumbnail") {
        return {
          ...state,
          loading: false,
          imageSrc: null,
        };
      }

      return state;
    },
    {
      imageSrc: null,
      loading: true,
    },
  );
}
